import React from 'react'
import useListScoredScenes from "./useListScoredScenes";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";
import ScoredScenesSectionOfGivenListSlim from "./ScoredScenesSectionOfGivenListSlim";
import {useIntl} from "react-intl";

const ScoredScenesSectionOfVideoSlim = ({videoKey}) => {
    const {
        scoredScenes,
        loading
    } = useListScoredScenes(videoKey)

    // Internationalization for simple strings
    const intl = useIntl();

    // Show loading indication while loading the list of users
    if (loading) {
        return <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.scoredScene.overview.slim.loading',
                defaultMessage: 'Loading Video Scenes...'
            })}/>
    }

    return <ScoredScenesSectionOfGivenListSlim scoredScenes={scoredScenes}/>
}
export default ScoredScenesSectionOfVideoSlim
